// src/pages/msp-inventory/hooks/usePersistedState.js
import { useState, useEffect } from "react";

// Generic localStorage-backed state — used to remember sort order, page,
// group-by, basis, threshold, and date range per report, so returning to any
// report page (or the SKU detail page) shows exactly what you left it at.
export const usePersistedState = (storageKey, defaultValue) => {
    const [state, setState] = useState(() => {
        try {
            const raw = localStorage.getItem(storageKey);
            return raw ? { ...defaultValue, ...JSON.parse(raw) } : defaultValue;
        } catch {
            return defaultValue;
        }
    });

    useEffect(() => {
        try { localStorage.setItem(storageKey, JSON.stringify(state)); } catch { /* ignore */ }
    }, [storageKey, state]);

    return [state, setState];
};